var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"no-underline inline-flex fix",attrs:{"to":_vm.localizedRoute('/'),"title":_vm.$t('Home Page')}},[_c('img',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.storeCode === 'zaun24_de' ? '/assets/logo.svg' : '/assets/logo-at.svg',"alt":_vm.defaultTitle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }